module.exports = __webpack_public_path__ + "img/7.089d25b6.jpg";